import useMutationStandCreateUpdate from './stand-use-mutation-create-update';
import useMutationStandDelete from "./stand-use-mutation-delete";
import useMutationStandUploadFile from './stand-use-mutation-upload-file';
import useMutationStandKeyCreate from './stand-key-use-mutation-create';
import useMutationStandKeyUpdate from './stand-key-use-mutation-update';
import useMutationStandKeyDelete from "./stand-key-use-mutation-delete";
import useMutationStandsActions from './stand-use-mutation-actions';
import useMutationStandReport from './stand-use-mutation-report';
import useQueryStandComments from "./stand-use-query-comments";
import useLazyQueryStandComment from "./stand-use-lazy-query-comment";
import useMutationStandCommentCreate from "./stand-comment-use-mutation-create";
import useMutationStandCommentUpdate from "./stand-comment-use-mutation-update";
import useMutationStandCommentDelete from "./stand-comment-use-mutation-delete";
import useMutationStandAttachmentCreate from "./stand-attachment-use-mutation-create";
import useMutationStandAttachmentDelete from "./stand-attachment-use-mutation-delete";


export const standUseMutation = {
  createUpdate: useMutationStandCreateUpdate,
  delete: useMutationStandDelete,
  keyCreate: useMutationStandKeyCreate,
  keyUpdate: useMutationStandKeyUpdate,
  keyDelete: useMutationStandKeyDelete,
  UploadFile: useMutationStandUploadFile,
  actions: useMutationStandsActions,
  report: useMutationStandReport,
  queryComments: useQueryStandComments,
  lazyQueryComment: useLazyQueryStandComment,
  commentCreate: useMutationStandCommentCreate,
  commentUpdate: useMutationStandCommentUpdate,
  commentDelete: useMutationStandCommentDelete,
  attachmentCreate: useMutationStandAttachmentCreate,
  attachmentDelete: useMutationStandAttachmentDelete,
};